import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReviewState {
  rating: number;
  reviewMsg: string;
}

interface ReviewProps {
  IsOpenReviewModal: boolean;
  reviewState: ReviewState;
}

const initialState: ReviewProps = {
  IsOpenReviewModal: false,
  reviewState: {
    rating: 0,
    reviewMsg: "",
  },
};

const ReviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    openReviewModel: (state) => {
      state.IsOpenReviewModal = true;
      state.reviewState = { rating: 0, reviewMsg: "" }; 
    },
    closeReviewModel: (state) => {
      state.IsOpenReviewModal = false;
    },
    changeReview: (state, action: PayloadAction<ReviewState>) => {
      state.reviewState = action.payload; 
    },
    resetReview: (state) => {
      state.reviewState = { rating: 0, reviewMsg: "" }; 
    },
  },
});

export const { openReviewModel, closeReviewModel, changeReview, resetReview } =
  ReviewSlice.actions;
export default ReviewSlice;
